import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, Spinner } from '@opendate-app/setlist';

const OpendateDistributionTermsModal = ({ open, agreeing, onDecline, onAgree }) => (
  <Modal
    open={open}
    width={600}
    title="Opendate Distribution Terms & Conditions"
    closeOnBackdrop={!agreeing}
    closeOnEsc={!agreeing}
    showClose={!agreeing}
    onClose={() => {
      if (!agreeing) onDecline();
    }}
    footer={
      <>
        <Button variant="secondary" disabled={agreeing} onClick={onDecline}>
          Decline
        </Button>
        <Button variant="primary" disabled={agreeing} onClick={onAgree}>
          {agreeing ? <Spinner size="sm" color="currentColor" aria-label="Agreeing to terms" /> : "I Agree"}
        </Button>
      </>
    }
  >
    <div style={{"maxHeight": "50vh", "overflowY": "auto", "fontSize": "14px", "lineHeight": "1.6", "color": "var(--sl-text-secondary)"}}>
      <p>
        <strong>1. Distribution Agreement.</strong> By enabling Opendate Distribution, you authorize Opendate to list and sell your tickets through selected third party marketplaces and resale platforms. You acknowledge that such sales are subject to the applicable third party's terms, fees, policies, and settlement timelines, and you agree to comply with all requirements necessary to facilitate distribution and fulfillment. You agree that Opendate is not responsible for any third party errors, delays, policy changes, suspensions, terminations, chargebacks, or other actions.
      </p>
      <p>
        <strong>2. Pricing & Fees.</strong> You understand that tickets distributed through Opendate Distribution are subject to additional fees paid for by the buyer, including but not limited to partner marketplace fees, processing fees and service fees.
      </p>
      <p>
        <strong>3. Inventory Management.</strong> You are responsible for ensuring that ticket inventory made available through Opendate Distribution is accurate and up to date. Opendate will sync inventory in real time, but you acknowledge that brief delays may occur. Overselling due to manual inventory adjustments is your responsibility.
      </p>
      <p>
        <strong>4. Settlement.</strong> You understand and agree that proceeds from tickets sold through Opendate Distribution will be remitted to you only after the applicable third party has settled funds to Opendate, and such payouts will occur post-event unless provided earlier by the third party.
      </p>
      <p>
        <strong>5. Revocation.</strong> You may disable Opendate Distribution at any time. Disabling distribution will remove unsold inventory from partner marketplaces but will not affect tickets already sold through those channels.
      </p>
      <p>
        <strong>6. Liability.</strong> You agree that Opendate is not responsible for any third party errors, delays, policy changes, suspensions, terminations, chargebacks, or other actions. Any disputes arising from sales on partner marketplaces will be handled in accordance with those platforms' policies.
      </p>
    </div>
  </Modal>
);

OpendateDistributionTermsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  agreeing: PropTypes.bool,
  onDecline: PropTypes.func.isRequired,
  onAgree: PropTypes.func.isRequired,
};

export default OpendateDistributionTermsModal;
